import { useMutation } from '@tanstack/react-query';
import setPatientUser from '@core/api/setPatientUser';
import { PatientUser } from '@core/types/User';

const useAddPatientUser = () => {
  const mutationFn = (user: PatientUser) => setPatientUser(user);
  const { isPending, mutateAsync: addPatientUser } = useMutation({
    mutationFn: mutationFn,
  });

  return { isPending, addPatientUser };
};

export default useAddPatientUser;
